import { render } from "./RegistrationForm.vue?vue&type=template&id=89f98af8&ts=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=ts"
export * from "./RegistrationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__